<script>
    import f9link from "inputs/f9link.vue";
    import f9button from "inputs/f9button.vue";
    import { getIbeHost } from "shared/Utilities/fetchUtilities";
    import { attachToMemberEvent, getBaseMemberData } from "shared/member";
    import { logout, attachToLogoutEvent } from "shared/login";

    export default {
        props: {
            "menuData": Object,
            "profileLink": String,
            "headerLinks": Array
        },
        data() {
            return {
                showTravel: false,
                showDeals: false,
                showFrontier: false,
                member: {},
                isEs: window.location.host.indexOf("es.") === 0
            };
        },
        mounted() {
            attachToMemberEvent("baseMemberLoaded", event => this.member = event.detail.data);
            attachToLogoutEvent(x => this.member = x ? { isLoggedIn: false } : this.member);

            this.$nextTick(() => getBaseMemberData(true, this.getHost()).then(member => this.member = member));
        },
        computed: {
            creditCardText() {
                return this.member.isBarclaysMember ? this.menuData.deals.existingCardHolder : this.menuData.deals.creditCard.content;
            },
            myFrontierRightSectionLinkNewWindow() {
                return this.menuData.myFrontier.rightSectionImageAndLinkNotSignedIn.umbracoLink.newWindow ? "_blank" : "self";
            }

        },
        methods: {
            lastMyFrontierLink(index){
                if(!this.member.isDiscountDenMember && index == 2){
                    return true;
                }
                if(!this.member.isBarclaysMember && index == 1 && this.member.isDiscountDenMember)
                {
                    return true;
                }
                return false;
            },
            hideNav() {
                this.showTravel = this.showDeals = this.showFrontier = false;
            },
            hoverNav(which) {
                this.hideNav();
                this[`show${which}`] = true;
            },
            getHost() {
                return getIbeHost();
            },
            logout() {
                logout(this.getHost());
            },
            getMyFrontierDataPoint(index) {
                switch(index) {
                    case 0: return true;
                    case 1: return this.member.isBarclaysMember;
                    case 2: return this.member.isDiscountDenMember;
                }
            },
            getLink(link) {
                if(this.isEs) {
                    return String(link).replace("www.flyfrontier", "es.flyfrontier");
                }
                return link;
            }
        },
        components: {
            f9link,
            f9button
        }
    }
</script>

<template>
    <div class="nav-desktop-container horizontal center around" @mouseleave="hideNav">
        <div v-if="headerLinks.length" class="headerlink-container">
            <f9link v-for="headerLink in headerLinks" :new-window="headerLink.newWindow" :key="headerLink.id" 
                  nostyle  :href="getLink(headerLink.link)" class="nav-link" v-html="headerLink.text">
            </f9link>
        </div>
        <div class="nav-desktop-container horizontal center around" v-else>
            <div class="nav-header-item travel">
                <f9link nostyle :href="getLink(menuData.travel.link.link)" class="nav-link" :new-window="menuData.travel.link.newWindow" :aria-expanded="showTravel"
                    @focus.native="hoverNav('Travel')" @mouseover.native="hoverNav('Travel')" v-html="menuData.travel.name">
                </f9link>
                <div class="arrow" v-show="showTravel"></div>
            </div>
            <div class="nav-items body-width travel" ref="navItems" v-show="showTravel">
                <div class="nav-item-header horizontal center left">{{menuData.travel.name}}</div>
                <div class="nav-item-content horizontal top between">
                    <div v-for="section in menuData.travel.sections" class="nav-section vertical left" :key="section.id">
                        <div class="nav-section-sub-head" v-html="section.name"></div>
                        <f9link v-for="link in section.links" :new-window="link.newWindow" :key="link.id" 
                            nostyle :href="getLink(link.link)" class="full-width nav-section-item" v-html="link.caption">
                        </f9link>
                    </div>
                </div>
            </div>
            <div class="nav-header-item deals">
                <f9link nostyle :href="getLink(menuData.deals.link.link)" class="nav-link" :new-window="menuData.deals.link.newWindow" :aria-expanded="showDeals"
                        @focus.native="hoverNav('Deals')" @mouseover.native="hoverNav('Deals')" v-html="menuData.deals.name">
                </f9link>
                <div class="arrow" v-show="showDeals"></div>
            </div>
            <div class="nav-items body-width deals" ref="navItems" v-show="showDeals">
                <div class="nav-item-header horizontal center left" v-html="menuData.deals.name"></div>
                <div class="nav-item-content horizontal top between">
                    <div class="nav-section">
                        <div class="nav-section-sub-head" v-html="menuData.deals.section.name"></div>
                        <f9link v-for="(link, index) in menuData.deals.section.links" :new-window="link.newWindow" :key="link.id" nostyle :href="getLink(link.link)" 
                            class="nav-section-item row-cb" :class="{ highlighted: index===0 }" v-html="link.caption">
                        </f9link>
                    </div>
                    <div class="nav-section extra no-pad">
                        <div class="card full-width to-edge green-background-light horizontal center between">
                            <img class="card-img" :src="menuData.deals.creditCard.imageUrl" :alt="menuData.deals.creditCard.imageAlt">
                            <span class="card-text vertical center left" v-html="creditCardText"></span>
                            <f9link nostyle v-if="!member.isBarclaysMember" class="card-button horizontal center" :new-window="menuData.deals.creditCard.link.newWindow" 
                                :href="getLink(menuData.deals.creditCard.link.link)" v-html="menuData.deals.creditCard.link.caption">
                            </f9link>
                        </div>
                        <div class="terms" v-if="!member.isBarclaysMember" v-html="menuData.deals.subText"></div>
                    </div>
                </div>
            </div>
            <div class="nav-header-item frontier">
                <f9link nostyle :href="getLink(menuData.myFrontier.link.link)" :new-window="menuData.myFrontier.link.newWindow" class="nav-link horizontal top around" :aria-expanded="showFrontier"
                    @focus.native="hoverNav('Frontier')" @mouseover.native="hoverNav('Frontier')">
                    <i v-html="menuData.myFrontier.name"></i>
                    &nbsp;Miles
                </f9link>
                <div class="arrow" v-show="showFrontier"></div>
            </div>
            <div class="nav-items body-width frontier" ref="navItems" v-show="showFrontier">
                <div class="nav-item-header horizontal center left">                    
                    <i v-html="menuData.myFrontier.name"></i>
                    &nbsp;Miles
                    <span class="sm">sm</span>
                </div>
                <div class="nav-item-content horizontal top stretch">
                    <div class="nav-section full-height">
                        <div class="nav-section-sub-head" v-html="menuData.myFrontier.leftSection.name"></div>
                        <f9link v-for="link in menuData.myFrontier.leftSection.links" :new-window="link.newWindow" :key="link.id" nostyle :href="getLink(link.link)" 
                            class="nav-section-item row-cb" v-html="link.caption">
                        </f9link>
                    </div>
                    <div class="nav-section full-height vertical top left" v-if="!member.isLoggedIn">
                        <div class="nav-section-sub-head">Earn Miles! <f9button nostyle class="signup-link" @click="$emit('signup')">SIGN UP TODAY</f9button></div>
                        <div class="nav-section-item center left"><i class="img checkmark"></i><span>Earn Miles and Points for every $1 you spend at Flyfrontier.com!</span></div>
                        <div class="nav-section-item center left"><i class="img checkmark"></i><span>Redeem Travel Miles for award flights!</span></div>
                        <div class="nav-section-item center left"><i class="img checkmark"></i><span>Gain points to achieve Elite Status and get FREE bags, seats, and additional benefits</span></div>
                    </div>
                    <div class="nav-section full-height vertical left between no-pad" v-else>
                        <div class="vertical left to-edge">
                            <div class="nav-section-sub-head" v-html="menuData.myFrontier.rightSection.name"></div>
                            <f9link v-for="link in menuData.myFrontier.rightSection.links" :new-window="link.newWindow" :key="link.id" nostyle :href="getLink(link.link)" 
                                class="nav-section-item row-cb auto" v-html="link.caption">
                            </f9link>
                            <div @focusout="{member.isBarclaysMember && member.isDiscountDenMember ? hideNav(): null}">
                                <f9button nostyle class="a nav-section-item row-cb auto" @click="logout">Logout</f9button>
                            </div>
                        </div>
                        <div class="my-frontier-links full-width to-edge">
                            <div class="nav-section-sub-head horizontal top left">
                                <i>FRONTIER Miles</i><span class="sm">sm</span>&nbsp;<span>ACCOUNT OVERVIEW</span>
                            </div>
                            <div v-for="(section, index) in menuData.myFrontier.accountOverviewSections" :key="section.id" class="my-section horizontal center between full-width" 
                                :class="{ 'green-background-light': getMyFrontierDataPoint(index) }">
                                <span v-html="section.name"></span>
                                <span v-if="getMyFrontierDataPoint(index)" v-html="section.existing"></span>
                                <span v-else>
                                    <div v-for="link in section.links" :key="link.id" @focusout="{lastMyFrontierLink(index) ? hideNav() : null}">
                                        <f9link :new-window="link.newWindow" :key="link.index" nostyle :href="getLink(link.link)"
                                            class="auto my-link" v-html="link.caption">
                                        </f9link>
                                    </div>  
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="nav-section horizontal pointer" v-if="!member.isLoggedIn" @focusout="hideNav">
                        <a :href="menuData.myFrontier.rightSectionImageAndLinkNotSignedIn.umbracoLink.link" :target="myFrontierRightSectionLinkNewWindow">
                            <img :src="menuData.myFrontier.rightSectionImageAndLinkNotSignedIn.imgSrc" :alt="menuData.myFrontier.rightSectionImageAndLinkNotSignedIn.imgAlt">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    @import "~less-mixins";
    
    .nav-desktop-container {
        height: 70px;
        font-size: 18px;
        font-weight: 700;
        
        .nav-header-item {
            position: relative;

            &.frontier {
                margin-top: 2px;
            }

            .nav-link {
                padding-right: 20px;
            }

            .arrow {
                .arrow-up(27px, 24px, @white);
                position: absolute;
                top: 28px;
                z-index: 1001;
            }

            &.travel {
                .arrow {
                    left: 10px;
                }
            }

            &.deals {
                .arrow {
                    left: 5px;
                }
            }

            &.frontier {
                .arrow {
                    left: 35px;
                }
            }
        }

        .nav-items {
            z-index: 1001;
            background-color: @white;
            color: @frontier-gray-xxdark;
            position: absolute;
            top: 80px;
            left: 0px;
            padding: 5px 6px;
            min-height: 400px;

            .nav-item-header {
                width: 100%;
                color: @frontier-green;
                background-color: @ibe-background--light-gray;
                font-size: 18px;
                font-weight: 600;
                padding-left: 28px;
                height: 44px;
            }

            .nav-item-content {
                padding: 19px 0;

                .nav-section {
                    flex: 1;
                    padding: 0 34px;
                    height: 100%;
                    min-height: 308px;

                    &.pointer {
                        cursor: pointer;
                    }

                    &.extra {
                        flex: 5;
                    }

                    &.no-pad {
                        padding-right: 0;
                    }

                    &:first-of-type {
                        max-width: 285px;
                    }

                    &:not(:first-of-type) {
                        border-left: 1px solid @frontier-gray-xxlighter;
                    }

                    .signup-link {
                        color: @frontier-green;
                        text-decoration: underline;
                        cursor: pointer;

                        &:hover {
                            color: @frontier-blue;
                        }
                    }

                    .terms {
                        font-size: 11px;
                        font-weight: 300;
                        margin: 11px 35px;
                        text-align: right;

                        @{deep} a {
                            color: @ibe-text--gray;

                            &:hover {
                                text-decoration: underline;
                            }
                        }
                    }

                    .checkmark {
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        margin-right: 3px;
                        margin-top: -3px;
                        background-image: url(https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/BlueCheckmark.png); 
                    }

                    .nav-section-sub-head {
                        padding-bottom: 12px;
                        font-size: 16px;
                        font-weight: 600;
                        text-transform: uppercase;
                        color: @frontier-gray-xxdark;
                    }

                    a, .a {
                        &.nav-section-item:hover {
                            color: @ibe-text-blue;
                            font-weight: 600;
                        }
                    }

                    .nav-section-item {
                        display: inline-block;
                        width: 100%;
                        padding-bottom: 10px;
                        font-size: 14px;
                        font-weight: 400;
                        color: @ibe-text--light-bluegray;

                        &.highlighted {
                            color: @ibe-text--red !important;
                        }

                        &.auto {
                            width: auto;
                        }
                    }

                    .to-edge {
                        margin-left: 6px;
                    }

                    .my-frontier-links {

                        .my-section {
                            padding-left: 19px;
                            padding-right: 64px;
                            height: 44px;
                            font-size: 14px;
                            font-weight: 400;
                            margin-bottom: 6px;

                            &:not(.green-background-light) {
                                background-color: @ibe-background--light-gray;
                            }

                            .my-link {
                                color: @frontier-green;
                                font-size: 12px;
                                font-weight: 600;
                                text-transform: uppercase;
                                position: relative;
                                margin-right: 15px;

                                &:after {
                                    content: '+';
                                    margin-left: 3px;
                                    font-size: 26px;
                                    font-weight: 400;
                                    position: absolute;
                                    top: -10px;
                                }

                                &:hover {
                                    color: @frontier-blue;
                                }
                            }
                        }
                    }

                    .card {
                        .card-img {
                            height: 76px;
                            margin: 45px 10px 45px 45px;
                        }

                        .card-text {
                            @{deep} p {
                                font-size: 16px;
                                font-style: italic;
                                font-weight: 400;
                                margin-bottom: 0;

                                &:first-of-type {
                                    font-style: normal;
                                    font-size: 28px;
                                    font-weight: 600;
                                }
                            }
                        }
                    }

                    .card-button {
                        height: 47px;
                        width: 200px;
                        border: 1px solid @white;
                        background-color: @frontier-green;
                        margin: 45px 45px 45px 10px;

                        &:hover, &:active {
                            background-color: @frontier-blue;
                        }
                    }
                }
            }
        }
        
        .sm {
            font-size: 7px;
            font-weight: 400;
            margin-bottom: 11px;
            text-transform: lowercase;
            padding-top: 3px;
        }
    }
</style>